import CompareTable from "../Pharmacy/PharmacyPlan/PharmacyCompareTable";
import { TABLE_STYLES } from "../Pharmacy/PharmacyPlan/PharmacyPlan.constants";
import { getDefaultCollapsed, ORIGIN_TITLE, shouldIncludeComparisonItem, STICKY_HEADER_HEIGHT, TARGET_TITLE } from "./Compare.constants";
import CompareRow from "./CompareRow";
import { CompareTitle } from "./CompareTitle";
import CustomPanel, { EPanelStyleType } from "./CustomPanel";
import { IEntityMetadataSectionProps } from "./types";

const EntityPropertiesPanel: React.FC<IEntityMetadataSectionProps> = (props) => {
    if (shouldIncludeComparisonItem(props.entityProps.configuration.showDifferencesOnly, props.entityProps.compareVM.propertiesVM.changed)) {
        const propertyRows: JSX.Element[] = [];

        props.entityProps.compareVM.propertiesVM.rowsVM.forEach((property) => {
            if (!shouldIncludeComparisonItem(props.entityProps.configuration.showDifferencesOnly, property.changed)) {
                return;
            }

            propertyRows.push(
                <CompareRow
                    key={property.propertyDefinition.name}
                    name={<CompareTitle
                        changed={property.changed}
                        name={property.propertyDefinition.name}
                        entityProps={props.entityProps}
                    />}
                    valueVM={{
                        mergeAction: property.mergeAction,
                        changed: property.changed,
                        origin: property.origin,
                        target: property.target,
                    }}
                    entityProps={props.entityProps}
                />
            );
        });

        return (
            <CustomPanel
                id={`${props.entityProps.compareVM.uniqueId}-properties`}
                key={`${props.entityProps.compareVM.uniqueId}-properties`}
                data-properties={'true'}
                title={<CompareTitle
                    changed={props.entityProps.compareVM.propertiesVM.changed}
                    name={'Properties'}
                    entityProps={props.entityProps}
                />}
                defaultCollapsed={getDefaultCollapsed(props.entityProps.configuration, props.entityProps.compareVM.propertiesVM.changed)}
                canCollapse={true}
                stickyHeader={true}
                stickyTop={props.entityProps.stickyOffset + STICKY_HEADER_HEIGHT}
                stickyZIndex={150}
                styleType={EPanelStyleType.Default}
            >
                <CompareTable
                    className={props.entityProps.classNames}
                    tableStyles={TABLE_STYLES}
                    originHeader={ORIGIN_TITLE}
                    targetHeader={TARGET_TITLE}
                    hideActionHeader={true}
                >
                    {propertyRows}
                </CompareTable>
            </CustomPanel>
        );
    }

    return null;
};

export default EntityPropertiesPanel;